import * as React from 'react';
import styled, { css } from 'react-emotion';
import { H1 } from '../../ui/H1';
const Wrapper = styled.div `
  background: #fff;
  ${p => p.theme.docz.mq({
    padding: [
        '50px 30px 30px',
        '50px 40px 30px',
        '50px 40px 30px',
        '40px 40px 30px',
    ],
})};
`;
const Breadcrumb = styled.span `
  color: ${p => p.theme.docz.colors.primary};
  font-size: 0.75rem;
  font-weight: bold;
  letter-spacing: 1px;
  text-transform: uppercase;
  ${(p) => p.isNested &&
    css `
      &:not(:last-of-type):after {
        content: '>';
        display: inline-block;
        margin: 0 5px;
      }
    `};
`;
const Name = styled(H1) `
  ${p => p.theme.docz.mq({
    margin: ['.5rem 0 1rem', '.5rem 0 1rem', '.5rem 0 1rem', '.5rem 0 1rem'],
})};
`;
const Subtitle = styled.p `
  font-size: 22px;
  font-weight: 300;
`;
export const Header = ({ name, menu = '', subtitle = '', }) => (React.createElement(Wrapper, null,
    Array.isArray(menu) ? (menu.map(item => (React.createElement(Breadcrumb, { key: typeof item === 'string' ? item : item.name, isNested: true }, typeof item === 'string' ? item : item.name)))) : (React.createElement(Breadcrumb, null, menu)),
    React.createElement(Name, null, name),
    React.createElement(Subtitle, null, subtitle)));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvY29tcG9uZW50cy9zaGFyZWQvSGVhZGVyL2luZGV4LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEtBQUssS0FBSyxNQUFNLE9BQU8sQ0FBQTtBQUU5QixPQUFPLE1BQU0sRUFBRSxFQUFFLEdBQUcsRUFBRSxNQUFNLGVBQWUsQ0FBQTtBQUUzQyxPQUFPLEVBQUUsRUFBRSxFQUFFLE1BQU0sYUFBYSxDQUFBO0FBWWhDLE1BQU0sT0FBTyxHQUFHLE1BQU0sQ0FBQyxHQUFHLENBQUE7O0lBRXRCLENBQUMsQ0FBQyxFQUFFLENBQ0osQ0FBQyxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDO0lBQ2QsT0FBTyxFQUFFO1FBQ1AsZ0JBQWdCO1FBQ2hCLGdCQUFnQjtRQUNoQixnQkFBZ0I7UUFDaEIsZ0JBQWdCO0tBQ2pCO0NBQ0YsQ0FBQztDQUNMLENBQUE7QUFFRCxNQUFNLFVBQVUsR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFBO1dBQ25CLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLE9BQU87Ozs7O0lBS3ZDLENBQUMsQ0FBa0IsRUFBRSxFQUFFLENBQ3ZCLENBQUMsQ0FBQyxRQUFRO0lBQ1YsR0FBRyxDQUFBOzs7Ozs7S0FNRjtDQUNKLENBQUE7QUFFRCxNQUFNLElBQUksR0FBRyxNQUFNLENBQUMsRUFBRSxDQUFDLENBQUE7SUFDbkIsQ0FBQyxDQUFDLEVBQUUsQ0FDSixDQUFDLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUM7SUFDZCxNQUFNLEVBQUUsQ0FBQyxjQUFjLEVBQUUsY0FBYyxFQUFFLGNBQWMsRUFBRSxjQUFjLENBQUM7Q0FDekUsQ0FBQztDQUNMLENBQUE7QUFFRCxNQUFNLFFBQVEsR0FBRyxNQUFNLENBQUMsQ0FBQyxDQUFBOzs7Q0FHeEIsQ0FBQTtBQUVELE1BQU0sQ0FBQyxNQUFNLE1BQU0sR0FBcUIsQ0FBQyxFQUN2QyxJQUFJLEVBQ0osSUFBSSxHQUFHLEVBQUUsRUFDVCxRQUFRLEdBQUcsRUFBRSxHQUNkLEVBQUUsRUFBRSxDQUFDLENBQ0osb0JBQUMsT0FBTztJQUNMLEtBQUssQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQ3JCLElBQUksQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUNmLG9CQUFDLFVBQVUsSUFDVCxHQUFHLEVBQUUsT0FBTyxJQUFJLEtBQUssUUFBUSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxJQUFJLEVBQ2hELFFBQVEsRUFBRSxJQUFJLElBRWIsT0FBTyxJQUFJLEtBQUssUUFBUSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQ2pDLENBQ2QsQ0FBQyxDQUNILENBQUMsQ0FBQyxDQUFDLENBQ0Ysb0JBQUMsVUFBVSxRQUFFLElBQUksQ0FBYyxDQUNoQztJQUNELG9CQUFDLElBQUksUUFBRSxJQUFJLENBQVE7SUFDbkIsb0JBQUMsUUFBUSxRQUFFLFFBQVEsQ0FBWSxDQUN2QixDQUNYLENBQUEifQ==